import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FileTextOutlined } from '@ant-design/icons';
import {
    TEST_PLAN_TEMPLATE__SIMPLEX,
    TEST_PLAN_TEMPLATE__DUPLEX,
    TEST_PLAN_TEMPLATE__MULTIFIBER,
    TEST_PLAN_TEMPLATE__FAN_OUT,
    CORE_SIZE__SINGLEMODE,
    CORE_SIZE__MULTIMODE_50,
    CORE_SIZE__MULTIMODE_62_5
} from '@shared/constants/constants';
import simplexAqua from './1_simplex_A_aqua_square.png';
import simplexGreyscale from './1_simplex_A_BW_square.png';
import simplexOrange from './1_simplex_A_orange_square.png';
import simplexYellow from './1_simplex_A_yellow_square.png';
import duplexAqua from './2_duplex_B_aqua_square.png';
import duplexGreyscale from './2_duplex_B_BW_square.png';
import duplexOrange from './2_duplex_B_orange_square.png';
import duplexYellow from './2_duplex_B_yellow_square.png';
import multifiberAqua from './4_multifiber_A_aqua_square.png';
import multifiberGreyscale from './4_multifiber_A_BW_square.png';
import multifiberOrange from './4_multifiber_A_orange_square.png';
import multifiberYellow from './4_multifiber_A_yellow_square.png';
import fanOutAqua from './5_fanout_to_multifiber_B_aqua_square.png';
import fanOutGreyscale from './5_fanout_to_multifiber_B_BW_square.png';
import fanOutOrange from './5_fanout_to_multifiber_B_orange_square.png';
import fanOutYellow from './5_fanout_to_multifiber_B_yellow_square.png';

export default class Cable extends Component {
    static propTypes = {
        coreSize: PropTypes.string,
        testPlanTemplate: PropTypes.string
    };

    render() {
        return (
            <React.Fragment>
                {
                    /* eslint-disable indent */
                    this.props.testPlanTemplate === TEST_PLAN_TEMPLATE__SIMPLEX ? (
                        this.props.coreSize === CORE_SIZE__SINGLEMODE ? (
                            <img src={simplexYellow} alt="cable" />
                        ) : this.props.coreSize === CORE_SIZE__MULTIMODE_50 ? (
                            <img src={simplexAqua} alt="cable" />
                        ) : this.props.coreSize === CORE_SIZE__MULTIMODE_62_5 ? (
                            <img src={simplexOrange} alt="cable" />
                        ) : (
                            <img src={simplexGreyscale} alt="cable" />
                        )
                    ) : this.props.testPlanTemplate === TEST_PLAN_TEMPLATE__DUPLEX ? (
                        this.props.coreSize === CORE_SIZE__SINGLEMODE ? (
                            <img src={duplexYellow} alt="cable" />
                        ) : this.props.coreSize === CORE_SIZE__MULTIMODE_50 ? (
                            <img src={duplexAqua} alt="cable" />
                        ) : this.props.coreSize === CORE_SIZE__MULTIMODE_62_5 ? (
                            <img src={duplexOrange} alt="cable" />
                        ) : (
                            <img src={duplexGreyscale} alt="cable" />
                        )
                    ) : this.props.testPlanTemplate === TEST_PLAN_TEMPLATE__MULTIFIBER ? (
                        this.props.coreSize === CORE_SIZE__SINGLEMODE ? (
                            <img src={multifiberYellow} alt="cable" />
                        ) : this.props.coreSize === CORE_SIZE__MULTIMODE_50 ? (
                            <img src={multifiberAqua} alt="cable" />
                        ) : this.props.coreSize === CORE_SIZE__MULTIMODE_62_5 ? (
                            <img src={multifiberOrange} alt="cable" />
                        ) : (
                            <img src={multifiberGreyscale} alt="cable" />
                        )
                    ) : this.props.testPlanTemplate === TEST_PLAN_TEMPLATE__FAN_OUT ? (
                        this.props.coreSize === CORE_SIZE__SINGLEMODE ? (
                            <img src={fanOutYellow} alt="cable" />
                        ) : this.props.coreSize === CORE_SIZE__MULTIMODE_50 ? (
                            <img src={fanOutAqua} alt="cable" />
                        ) : this.props.coreSize === CORE_SIZE__MULTIMODE_62_5 ? (
                            <img src={fanOutOrange} alt="cable" />
                        ) : (
                            <img src={fanOutGreyscale} alt="cable" />
                        )
                    ) : (
                        <div className="cable-icon">
                            <FileTextOutlined />
                        </div>
                    )
                    /* eslint-enable indent */
                }
            </React.Fragment>
        );
    }
}
